import React from 'react'

import { ApolloProvider } from '@apollo/react-hooks'
import { IntlProvider } from 'react-intl'
import { StylesProvider, ThemeProvider } from '@material-ui/core/styles'
import theme from '../themes/main'
import {
  Slide,
  ToastContainer
} from 'react-toastify'
import flatten from 'flat'

import localeMessages from '../../locale_messages.yml'
import client from '../apollo-client'
import Routes from '../Routes'

class Root extends React.Component {
  render() {
    return (
      <ApolloProvider client={ client }>
        <ThemeProvider theme={ theme }>
          <StylesProvider injectFirst>
            <IntlProvider key="pt-BR" locale="pt-BR" messages={ flatten(localeMessages['pt-BR']) }>
              <Routes />
              <ToastContainer
                closeOnClick
                hideProgressBar
                pauseOnHover
                autoClose={ 3000 }
                draggable={ false }
                position="bottom-right"
                transition={ Slide }
              />
            </IntlProvider>
          </StylesProvider>
        </ThemeProvider>
      </ApolloProvider>
    )
  }
}

export default Root
